interface QuotationItemListProps {
  items: {
    description: string;
    qty: number;
    unit: string;
    price: number;
    total: number;
  }[];
}

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value || 0);

export default function QuotationItemList({ items }: QuotationItemListProps) {
  return (
    <div className="rounded-2xl border border-gray-100 p-5">
      <h3 className="mb-4 font-semibold">Quotation Item</h3>

      <div className="space-y-4">
        {items.map((item, index) => (
          <div key={index} className="rounded-xl border border-gray-100 p-4">
            <div className="mb-2 flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 text-xs font-semibold text-blue-600">
              {index + 1}
            </div>

            <div className="grid grid-cols-2 gap-x-10 gap-y-1 text-sm">
              <Row label="Description" value={item.description} />
              <Row label="Price" value={formatCurrency(item.price)} />
              <Row label="QTY" value={String(item.qty)} />
              <Row label="Total" value={formatCurrency(item.total)} />
              <Row label="Unit" value={item.unit} />
            </div>
          </div>
        ))}

        {items.length === 0 && <p className="text-sm text-gray-400">No items.</p>}
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex">
      <span className="w-28 shrink-0 text-gray-500">{label}</span>
      <span className="mr-2">:</span>
      <span className="font-medium text-gray-800">{value}</span>
    </div>
  );
}
